module.exports = __webpack_public_path__ + "static/media/correct.107e5d28.wav";